module.exports = __webpack_public_path__ + "media/images/ilustrations/ilustration-1-2-d281b1465bb64faf95eda8b1b88d3e26.png";